import { InfoCompletenessScoring } from 'store/api/apiTypes';

export type TechnicalFindingsViewMode = 'text' | 'matrix';

type TechnicalRuleLevel = NonNullable<InfoCompletenessScoring['level']>;

interface TechnicalFindingsViewModeParams {
  ruleKey: string;
  level: InfoCompletenessScoring['level'];
}

interface RuleFindingsPolicy
  extends Partial<Record<TechnicalRuleLevel, TechnicalFindingsViewMode>> {
  default: TechnicalFindingsViewMode;
}

const TECHNICAL_FINDINGS_VIEW_POLICY: Record<string, RuleFindingsPolicy> = {
  'robots-txt': {
    default: 'text',
    medium: 'matrix',
  },
  file: {
    default: 'text',
  },
  structure: {
    default: 'text',
    medium: 'matrix',
    low: 'matrix',
  },
  products_section: {
    default: 'text',
  },
};

export const getTechnicalFindingsViewMode = ({
  ruleKey,
  level,
}: TechnicalFindingsViewModeParams): TechnicalFindingsViewMode => {
  const normalizedLevel = level ?? 'low';
  const policy = TECHNICAL_FINDINGS_VIEW_POLICY[ruleKey];

  if (policy) {
    return policy[normalizedLevel] ?? policy.default;
  }

  return normalizedLevel === 'high' ? 'text' : 'matrix';
};
